module.exports = __webpack_public_path__ + "img/122ne.714a9546.svg";